import { SelectorOption } from "../../../shared/components/filtering/filter.interfaces";
import { Page } from "../../shared/domain/models/page";

export class GetTimePeriodOptionsByIdsInteractor {
  public async execute(ids: string[]): Promise<Page<SelectorOption>> {
    const filteredIds = ids.map((id) => +id).filter((id) => !isNaN(+id));
    if (!filteredIds.length) {
      return Page.createWith([]);
    }

    return Promise.resolve(
      new Page(
        1,
        filteredIds.length,
        filteredIds.length,
        filteredIds.map((id, idx) => ({
          id: new Date(id),
          name: idx === 0 ? "start" : "end",
        })),
      ),
    );
  }
}
